import { NgapAct } from '../types/ngap';
import { SHARE_URLS, EMAIL_TEMPLATE } from '../constants/share';
import { MESSAGES } from '../constants/messages';
import { APP_INFO } from '../constants/app';
import { generateActUrl } from './urlUtils';

// Fonction pour générer le slug d'URL
export const generateSlug = (act: NgapAct): string => {
  const lettreClé = act.lettre_cle || 'acte';
  const cotationValeur = act.cotation_valeur.replace(',', '.');
  return `${lettreClé.toLowerCase()}-${cotationValeur}`;
};

// Fonction pour générer l'URL complète
export const generateShareUrl = (act: NgapAct): string => {
  // Utiliser l'URL spécifique de l'acte
  return `${APP_INFO.BASE_URL}${generateActUrl(act)}`;
};

// Fonction pour générer le texte de partage
export const generateShareText = (act: NgapAct): string => {
  return `Cotation NGAP ${act.lettre_cle || ''} ${act.cotation_valeur} - ${act.libelle}`;
};

// Fonction pour partager par email
export const shareByEmail = (act: NgapAct) => {
  const subject = encodeURIComponent(`${MESSAGES.PRICING.COTATION} NGAP ${act.lettre_cle || ''}`);
  const body = encodeURIComponent(
    `${EMAIL_TEMPLATE.GREETING}\n\n${EMAIL_TEMPLATE.INTRO}\n\n` +
    `${act.lettre_cle || ''} - ${act.libelle}\n` +
    `${EMAIL_TEMPLATE.COTATION_LABEL} ${act.cotation_valeur}\n\n` +
    `${EMAIL_TEMPLATE.LINK_LABEL} ${generateShareUrl(act)}\n\n` +
    `${EMAIL_TEMPLATE.CLOSING}`
  );
  window.open(`mailto:?subject=${subject}&body=${body}`);
};

// Fonction pour partager sur Twitter
export const shareOnTwitter = (act: NgapAct) => {
  const text = encodeURIComponent(
    `${generateShareText(act)} - ${generateShareUrl(act)}`
  );
  window.open(`${SHARE_URLS.TWITTER}${text}`, '_blank');
};

// Fonction pour partager sur LinkedIn
export const shareOnLinkedIn = (act: NgapAct) => {
  const url = encodeURIComponent(generateShareUrl(act));
  const title = encodeURIComponent(generateShareText(act));
  window.open(`${SHARE_URLS.LINKEDIN}${url}&title=${title}`, '_blank');
};

// Fonction pour partager sur Facebook
export const shareOnFacebook = (act: NgapAct) => {
  const url = encodeURIComponent(generateShareUrl(act));
  window.open(`${SHARE_URLS.FACEBOOK}${url}`, '_blank');
};

// Fonction pour copier le lien
export const copyShareLink = async (act: NgapAct): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(generateShareUrl(act));
    return true;
  } catch (err) {
    console.error('Erreur lors de la copie:', err);
    return false;
  }
};